// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"ec74453f","232":"443ba8bc","237":"5a9540d2","378":"de82c397","398":"56b6b893","526":"32732961","787":"128fc6e9","872":"9cd168e8"}[chunkId] + ".chunk.js";
};